import { get, post } from '@/utils/request'

export const queryPage = (p) => post('/user/queryPage', p)

export const saveUser = (p) => post('/user/saveUser', p)

export const delUser = (p) => post('/user/delUser', p)

export const login = (p) => post('/auth/login', p)

export const register = (p) => post('/auth/register', p)

export const getUserMenus = (p) => post('/user/getUserMenus', p)

export const modifyLoginPassword = (p) => post('/user/modifyLoginPassword', p)

export const getUserOptions = (p) => post('/user/getUserOptions', p)

export const getCaptchaUrl = `${process.env.REACT_APP_BASE_API}/auth/getCaptcha`